import { useEffect, useRef, useState } from "react";
import { useVideoPopup } from "./VideoPopup";
import { Play } from "lucide-react";

/**
 * YouTube card with hover-autoplay (muted) preview, click opens full popup with audio.
 */
export default function YouTubeHoverCard({ youtubeId, title, category, testid }) {
  const [hover, setHover] = useState(false);
  const [load, setLoad] = useState(false);
  const tref = useRef(null);
  const popup = useVideoPopup();

  useEffect(() => {
    if (hover) {
      tref.current = setTimeout(() => setLoad(true), 220);
    } else {
      clearTimeout(tref.current);
      setLoad(false);
    }
    return () => clearTimeout(tref.current);
  }, [hover]);

  const open = () => popup?.open?.({ youtubeId, title, eyebrow: category });

  return (
    <div
      className="relative group rounded-2xl overflow-hidden cursor-pointer lift"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={open}
      style={{ aspectRatio: "16/9", border: "1px solid rgba(255,255,255,0.06)", background: "#000" }}
      data-testid={testid}
    >
      <img
        src={`https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ opacity: load ? 0 : 1, transition: "opacity 0.4s ease" }}
        loading="lazy"
      />
      {load && (
        <iframe
          title={title}
          src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${youtubeId}&modestbranding=1&playsinline=1&rel=0&iv_load_policy=3`}
          className="absolute inset-0 w-full h-full pointer-events-none"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent pointer-events-none" />
      {/* Play button on hover */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="w-16 h-16 rounded-full bg-cyan-400/90 flex items-center justify-center shadow-[0_0_30px_rgba(0,184,255,0.6)]">
          <Play size={22} fill="#000" stroke="#000" />
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5 pointer-events-none">
        {category && <div className="label-mono mb-1 text-cyan-300/90">{category}</div>}
        <div className="font-display text-base font-semibold leading-tight">{title}</div>
      </div>
    </div>
  );
}
